export default {
  name: 'readMore',
  component(config) {
    return {
      // Configuration
      text: config.text || '',
      maxCharsDesktop: config.maxCharsDesktop || 300,
      maxCharsMobile: config.maxCharsMobile || 150,
      showMoreText: config.showMoreText || 'Show more',
      showLessText: config.showLessText || 'Show less',
      mobileBreakpoint: config.mobileBreakpoint || 768,

      // State
      isExpanded: false,
      isMobile: window.innerWidth < (config.mobileBreakpoint || 768),

      // Initialization
      init() {
        // Listen for window resize
        window.addEventListener('resize', () => {
          this.isMobile = window.innerWidth < this.mobileBreakpoint;
        });
      },

      // Computed properties
      get maxChars() {
        return this.isMobile ? this.maxCharsMobile : this.maxCharsDesktop;
      },

      get shouldTruncate() {
        return this.text.length > this.maxChars;
      },

      get displayText() {
        if (!this.shouldTruncate || this.isExpanded) {
          return this.text;
        }

        // Find the last complete word before the character limit
        const truncated = this.text.substring(0, this.maxChars);
        const lastSpaceIndex = truncated.lastIndexOf(' ');

        // If we found a space, truncate at the last complete word
        // Otherwise, truncate at the character limit
        return lastSpaceIndex > 0 ? truncated.substring(0, lastSpaceIndex) + '...' : truncated + '...';
      },

      get toggleText() {
        return this.isExpanded ? this.showLessText : this.showMoreText;
      },

      // Methods
      toggle() {
        this.isExpanded = !this.isExpanded;
      }
    };
  }
};
